import React from 'react';

const ACreceive = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 13.1665H3V11.4998H13V13.1665ZM13 9.83317H3V8.1665H13V9.83317ZM13 6.49984H3V4.83317H13V6.49984ZM0.5 17.3332L1.75 16.0832L3 17.3332L4.25 16.0832L5.5 17.3332L6.75 16.0832L8 17.3332L9.25 16.0832L10.5 17.3332L11.75 16.0832L13 17.3332L14.25 16.0832L15.5 17.3332V0.666504L14.25 1.9165L13 0.666504L11.75 1.9165L10.5 0.666504L9.25 1.9165L8 0.666504L6.75 1.9165L5.5 0.666504L4.25 1.9165L3 0.666504L1.75 1.9165L0.5 0.666504V17.3332Z" fill="currentColor"/>
    </svg>
  )
};

export default ACreceive;